import React, { Fragment } from 'react';

import useSafeSportProgramLevel from './UseSafeSportProgramLevel';

import RevokeSSRPForm from '../../../components/forms/RevokeSSRPForm';

import ProgramLevelGrid from '@usas/ui-web/components/grids/programLevel/ProgramLevelGrid';
import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SafeSportProgramLevel = ({ canRevokeSSRP = false }) => {
  const {
    isLoading,
    isSaving,
    recognitionProgramState,
    modalState,
    buttonsState,
    revokeModalState,
    onSubmitLevelInstance,
    onEditProgramLevel,
    onModalSubmit,
    onModalCanceled,
    onInitiateProgramLevel,
    onRenewProgramLevel,
    onRevokeSSRP,
    onRevokeSSRPModalSubmit,
    onRevokeSSRPModalCanceled
  } = useSafeSportProgramLevel();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Program Level</Headings.H3>
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        {buttonsState.showRenewButton === true &&
          <div className="col-xs-12 col-sm-4">
            <ActionIntraPageButton type='button' onClick={onRenewProgramLevel}>
              Renew Safe Sport Recognition Program
            </ActionIntraPageButton>
          </div>
        }
        {buttonsState.showInitiateButton === true &&
          <div className="col-xs-12 col-sm-4">
            <ActionIntraPageButton type='button' onClick={onInitiateProgramLevel}>
              Initiate Safe Sport Recognition Program
            </ActionIntraPageButton>
          </div>
        }
        {canRevokeSSRP === true && buttonsState.showRevokeButton === true &&
          <div className="col-xs-12 col-sm-4">
            <ActionIntraPageButton type='button' onClick={onRevokeSSRP}>
              Revoke SSRP
            </ActionIntraPageButton>
          </div>
        }
      </div>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12">
          <ProgramLevelGrid
            data={recognitionProgramState.arrayData}
            isLoading={recognitionProgramState.isArrayLoading}
            onSubmit={onSubmitLevelInstance}
            onEdit={onEditProgramLevel}
            showStatus={true}
          />
        </div>
      </div>
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={modalState.modalTitle}
        displayPopUp={modalState.displayPopUp}
        onModalCanceled={onModalCanceled}>
        {modalState.pointsErrors.length > 0 ?
          <div className="row">
            <div className="col-xs-12" >
              <p><b>Minimum Points Errors:</b></p>
              {modalState.pointsErrors.map((error, i) => <p key={i} className={global.ErrorMessage}>{error}</p>)}
            </div>
          </div> : <Fragment />
        }
        {modalState.requiredErrors.length > 0 ?
          <div className="row">
            <div className="col-xs-12" >
              <p><b>Requirement Errors:</b></p>
              {modalState.requiredErrors.map((error, i) => <p key={i} className={global.ErrorMessage}>{error}</p>)}
            </div>
          </div> : <Fragment />
        }
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            {modalState.canSubmit === true ?
              <Fragment><PrimaryButton type="button" onClick={onModalSubmit}>Yes, Submit Level</PrimaryButton>&nbsp;</Fragment>
              : <Fragment />}
            <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={'Revoke SSRP?'}
        displayPopUp={revokeModalState.displayPopUp}
        onModalCanceled={onRevokeSSRPModalCanceled}>
        <div className='row'>
          <div className='col-xs-12'>
            <p>To revoke the current Safe Sport Recognition Program, please select an Expiration Date.</p>
          </div>
        </div>
        {revokeModalState.displayPopUp === true &&
          <RevokeSSRPForm
            effectiveDate={buttonsState.currentProgramLevelEffectiveDate}
            onSubmitFormCallback={onRevokeSSRPModalSubmit}
            onSecondaryButtonClicked={onRevokeSSRPModalCanceled} />
        }
      </PopUpModal>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SUBMITTING_MSG}
        displayPopUp={isSaving} />
    </Fragment>
  );
};

export default SafeSportProgramLevel;